import {
  ApplicationConfig,
  provideZoneChangeDetection,
  isDevMode,
  ErrorHandler,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { provideRouter, withPreloading, NoPreloading } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import MyPreset from 'src/mypreset';
import { MessageService } from 'primeng/api';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { LoadingService } from '@core/services/loading.service';
import { languageInterceptor } from '@core/interceptors/language.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { GlobalErrorHandler } from '@core/errors/global-error.handler';
import { auditHttpInterceptor } from '@core/interceptors/audit-http.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),

    { provide: ErrorHandler, useClass: GlobalErrorHandler },

    providePrimeNG({
      theme: { preset: MyPreset, options: { darkModeSelector: '.dark' } },
    }),

    provideHttpClient(
      withInterceptors([
        languageInterceptor,
        authInterceptor,
        auditHttpInterceptor,
      ]),
    ),

    provideRouter(routes, withPreloading(NoPreloading)),

    DatePipe,
    MessageService,
    LoadingService,

    provideTransloco({
      config: {
        availableLangs: ['es', 'en'],
        defaultLang: 'es',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
